/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export { GraphCache };
class GraphCache {
    #factory;
    #graphs = new Map();
    constructor(factory) {
        this.#factory = factory;
    }
    rebuild(graph) {
        this.#graphs = new Map(Object.keys(graph.graphs || []).map((id) => [id, this.#factory(id)]));
        this.#graphs.set("", this.#factory(""));
    }
    get(id) {
        return this.#graphs.get(id);
    }
    add(id) {
        this.#graphs.set(id, this.#factory(id));
    }
    graphs() {
        return Object.fromEntries([...this.#graphs.entries()].filter(([id]) => id));
    }
    remove(id) {
        this.#graphs.delete(id);
    }
    clear() {
        this.#graphs.clear();
    }
}
//# sourceMappingURL=graph-cache.js.map